import type EnType from '../en-US/common';

export default {
  format: 'フォーマット',
  responsible: '担当者',
  defaultFolder: 'ルートフォルダー',
  export: 'エクスポート',
  delete: '削除',
  view: '確認',
  send: '送信',
  sending: '送信中',
  search: '検索',
  find: '探す',
  save: '保存',
  saveAndExit: '保存して閉じる',
  saved: '保存済み',
  cancel: 'キャンセル',
  close: '閉じる',
  name: '名前',
  description: '説明',
  updatedIn: '最終更新：',
  codeGenerate: 'コード生成',
  copyToClipboard: 'クリックしてコピー',
  'message.requestException': 'Request例外',
  'message.requestError': 'Requestエラー',
  'message.exportSuccess': 'エクスポートに成功しました',
  'message.networkFailure':
    'ネットワークエラーが発生しました。ネットワークを確認するか、後でもう一度お試しください',
  'message.serverFailure': 'サーバーエラーが発生しました。後でもう一度お試しください',
  'button.text.reload': '再読み込み',
  'message.loadError.checkNetwork':
    '読み込みエラーです。ネットワークがダウンしていないか確認してください',
  'message.scriptError.checkNetworkOrContactStaff':
    '異常なエラーが発生しました。再読み込みするか、スタッフに連絡して問題を解決してください！',
  dismiss: '以後表示しない',
  moreHelp: 'その他のヘルプ',
  noContent: '内容がありません',
  enumeratedValue: '列挙型(Enums)',
  value: '値',
  colon: '：',
  more: 'もっと見る',
  download: 'ダウンロード',
  downloadFileAndUnitSize: 'ファイルをダウンロード（{unitSize}）',
  viewAsText: 'テキストで表示',
  copyContent: 'コンテンツをコピー',
  wrap: '自動改行',
  request: 'Request',
  response: 'Response',
  'request.example.title.right': 'Request',
  'request.example.title.center': ' Request Example',
  'response.example.title.right': 'Response',
  'response.example.title.center': ' Response Example',
  redirect: 'リダイレクト',
  console: 'コンソール',
  header: 'Header',
  cookie: 'Cookie',
  selectCharset: '文字セットを選択してください',
  isCopied: 'コピーされました',
  failToCopied: 'コピーに失敗しました、手動でコピーしてください',
  graphqlGetTips:
    'HTTP GET Requestを送信する場合、クエリをParamsの「query」フィールドに定義する必要があります。',
  'runner.tryItOut': 'オンラインで実行',
  'runner.selectCase': 'ユースケースの選択',
  tryItOut: 'デバッグ',
  runInApp: 'Run in {appName}',
  clone: 'クローン',
  'customDomain.cname.alibaba': '阿里雲でドメイン登録',
  'customDomain.cname.otherCloud': '他のクラウドでドメイン登録',
  'customDomain.cname.HK': '香港のサーバー、やや遅い',
  onlineShareHasBeenCopyToTeam:
    'APIドキュメント <strong>【{onlineShareName}】</strong> をチーム <strong>【{teamName}】</strong> にコピーしました',
  'onlineShare.export': 'データをエクスポート',
  'onlineShare.export.dataType': 'データ形式の選択',
  'exportData.export.openapi.version': 'OpenAPI Spec バージョン',
  'exportData.export.openapi.version.31': 'OpenAPI 3.1',
  'exportData.export.openapi.version.30': 'OpenAPI 3.0',
  'exportData.export.openapi.version.20': 'Swagger 2.0',
  'exportData.export.openapi.includeExtension':
    '{appName}の拡張パロパティとなるOpenAPIフィールド（x-{appNameLower}-***）を含みますか',
  'exportData.export.openapi.includeExtension.no': 'いいえ',
  'exportData.export.openapi.includeExtension.yes': 'はい',
  'exportData.export.openapi.tags': 'APIのfolderをTagsフィールドとしてエクスポート',
  'exportData.export.openapi.tags.yes': 'はい',
  'exportData.export.openapi.tags.no': 'いいえ',
  'onlineShare.clone': '私の{appName}にクローンする',
  'onlineShare.notExisted': 'このドキュメントは存在しないか、削除されました。',
  'onlineShare.noAccess': 'このドキュメントサイトへのアクセス権がありません',
  'onlineShare.expired.subTitle': 'アクセスするには、ドキュメントの所有者に連絡してください。',
  'apidoc.unPublish': '現在のドキュメントはまだ公開されていません',
  'apidoc.unPublish.subTitle':
    '現在のURLにアクセスする前に、ドキュメントの管理者に連絡してドキュメントを公開してください。',
  'onlineShare.needPassword': 'このドキュメントにアクセスするにはパスワードが必要です',
  'onlineShare.sendCodeSuccess':
    'ホワイトリストに登録されているメールアドレスには、すぐに確認コードが届きます。',
  'exportData.appDocumentation.json': 'APIドキュメント.{appNameLower}.json',
  'onlineShare.resource.notExisted.title': '404',
  'onlineShare.resource.notExisted.subTitle': 'ページが見つかりません',
  'onlineShare.resource.notExisted.reload': 'ページを再読み込みする',
  backToHome: 'ホームに戻る',
  home: 'ホーム',
  'email.auth.tip': '現在のドキュメントサイトは、アクセスするためにメール認証コードが必要です。',

  'customDomain.error.tip': 'CNAME 設定が正しくありません。以下の仕様を確認してください。',
  'customDomain.error.tip2': 'CNAME 設定が正しくありません。',
  previous: '前へ',
  next: '次へ',
  'message.noPrivilege': '権限がありません',
  'onlineShare.expired': 'このドキュメントの有効期限が切れています。',
  'onlineShare.notShared': '現在のドキュメントはまだ公開されていません',

  'docsSite.enableVibeCodingViaMCP.suffix': 'API Specification',
  'docsSite.enableVibeCodingViaMCP': 'MCP',
  'docsSite.enableVibeCodingViaMCP.tooltip':
    'Cursor や GitHub Copilot などの AI ツールが完全な API ドキュメント サイトにアクセスできるようにすることで、Vibe Coding エクスペリエンスを強化します',
  'docsSite.enableVibeCodingViaMCP.modal.title': 'MCP',
  'docsSite.enableVibeCodingViaMCP.modal.description':
    '## 🚀 Configuration Guide\n\n### **Prerequisites**\n\n- **Node.js** (version 18 or higher, preferably the latest LTS version).\n- An IDE that supports MCP, such as:\n  - **Cursor**\n  - **VS Code + Cline plugin**\n\n### Configure the IDE\n\n- Copy the following JSON configuration code to add to the MCP configuration file in your IDE:\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "npx",\n      "args": [\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\nIf you\'re on **Windows** and the configuration file above isn\'t working, try using the configuration file below instead:\n\n```json\n{\n  "mcpServers": {\n    "{serverName}": {\n      "command": "cmd",\n      "args": [\n        "/c",\n        "npx",\n        "-y",\n        "{appNameLower}-mcp-server@latest",\n        "--site-id={docsSiteId}"\n      ]\n    }\n  }\n}\n```\n\n## 🎯 How {appName} MCP Server Works?\n\nOnce the {appName} MCP Server is set up, it automatically reads and caches all API documentation data on your local machine. The AI can then retrieve and utilize this data seamlessly.\n\nSimply instruct the AI on what you’d like to achieve with the API documentation. Here are some examples:\n\n1. **Generate Code**: "Use MCP to fetch the API documentation and generate Java records for the \'Product\' schema and related schemas".\n2. **Update DTOs**: "Based on the API documentation, add the new fields to the \'Product\' DTO".\n3. **Add Comments**: "Add comments for each field in the \'Product\' class based on the API documentation".\n4. **Create MVC Code**: "Generate all the MVC code related to the endpoint \'/users\' according to the API documentation".',

  'specialFile.menu.copy.label': 'ページをコピー',
  'specialFile.menu.copy.description': 'このページを LLM の Markdown としてコピーします',
  'specialFile.menu.markdown.label': 'Markdown形式で表示',
  'specialFile.menu.markdown.description': 'このページをプレーンテキストで表示する',
  'specialFile.menu.gpt.label': '{gptName} で開く',
  'specialFile.menu.gpt.prompt':
    '{link} から内容を読み取り、関連する質問を提出できるようにします。',
  'specialFile.menu.gpt.description': 'このページについて質問する',
  'specialFile.menu.llms.label': 'LLMs.txt',
  'specialFile.menu.llms.description':
    'LLM が完全な API ドキュメント サイトを使用できるようにするための情報を提供する',
  'specialFile.failToCopied':
    'コピーに失敗しました。Markdown を表示するには、ページ URL の後に .md を追加してください。',
  'docsSite.login.error': 'ログインに失敗しました',
  'docsSite.login.error.detail':
    'カスタムログインページから返されたJWTの署名検証に失敗しました。設定を変更するためにドキュメント発行者にお問い合わせください。',

  'apiTest.debug.dataSource.error':
    'Web版ではデータベース操作はサポートされていません。{appName}デスクトップ版をダウンロードして使用してください。',
  'apiTest.debug.execute.error':
    'Web版では外部プログラムの呼び出しはサポートされていません。{appName}デスクトップ版をダウンロードして使用してください。',
  'apiTest.debug.liveRequire.error':
    'Web版では外部ライブラリの動的な読み込みはサポートされていません。{appName}デスクトップ版をダウンロードして使用してください。',
  'customDomain.error.tip.canNotAccess':
    '現在のドキュメントサイトは、CNAME 設定のみを使用しており、直接アクセスできません。',
} satisfies typeof EnType;
